<template>
  <div id="app">
    <div id="nav">
      <span class="logout" v-if="isLoggedIn">
        <a @click="logout">Logout </a><i class="fas fa-sign-out-alt"></i
      ></span>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    }
  },
  created: function() {
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(function() {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap");
@import "../public/reset.css";
@import "../node_modules/bootstrap/dist/css/bootstrap.css";
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

#app {
  font-family: "Fira Sans", sans-serif;

  background-color: #213a4f;

  padding-bottom: 25px;
}

.logout {
  display: inline-block;
  position: relative;

  font-size: 20px;
  line-height: 40px;
  padding-right: 25px;

  margin-top: 25px;
  text-align: right;
  color: white !important;
  width: 100%;
  word-wrap: normal;

  cursor: pointer;
}

i.fas {
  width: 30px;
  height: 30px;

  font-size: 20px;
  line-height: 40px;

  text-align: center;
  margin-right: 0px;
  position: relative;
  z-index: 1;
  color: white;
}
</style>
